import { render } from "./MedicalHistory.vue?vue&type=template&id=22fc4adc&scoped=true"
import script from "./MedicalHistory.vue?vue&type=script&lang=js"
export * from "./MedicalHistory.vue?vue&type=script&lang=js"

import "./MedicalHistory.vue?vue&type=style&index=0&id=22fc4adc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fc4adc"]])

export default __exports__